<script setup>

const props = defineProps({
  link: {
    type: Object,
    default: {
      routerObj: {
        name: 'dashboard'
      }, 
      type: 'link', 
      desc: 'Go to Dashboard', 
      class: 'w-25'
    }
  },
  text: {
    type: String
  },
  needLink: {
    type: Boolean,
    default: true
  }
})
</script>

<template>
  <div class="text-center">
    <div>
      <img src="@/assets/images/no-data.svg" :class="props.link.class" alt="">
    </div>
    <div>
      <p>{{ props.link.text || props.text }}</p>
      <template v-if="needLink">
        <router-link  class="btn btn-success" 
          v-if="props.link.type == 'link'"
          :to="props.link.routerObj"
          >
          {{ props.link.desc }}
        </router-link>
        <a v-else class="btn btn-success" 
          :href="props.link.name"
        >
          {{ props.link.desc }}
        </a>
      </template>
    </div>
  </div>
</template>
